import { connect } from 'react-redux';
import { fetchOutlets } from 'reducers/paymentConfiguration/actions';
import get from 'lodash/get';
import OutletAssignmentModal from './OutletAssignmentModal';

function mapStateToProps(state) {
  const isOutletsLoaded = get(
    state,
    ['paymentConfiguration', 'isOutletsLoaded'],
    false
  );
  const outlets = get(state, ['paymentConfiguration', 'outlets'], []);

  return {
    isOutletsLoaded,
    outlets,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onLoad: () => {
      dispatch(fetchOutlets());
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OutletAssignmentModal);
